import { jsxs as H, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as L } from "./index.es2359.js";
function i({ size: l = L }) {
  return /* @__PURE__ */ H(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.468262", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M35.9444 16.9127C35.5456 16.9127 35.2222 17.2361 35.2222 17.6349V18.3572H17.8889C17.8889 19.9527 16.5955 21.2461 15 21.2461V23.7738C15 24.5716 15.6467 25.2183 16.4444 25.2183H41V18.3572H39.5556V17.6349C39.5556 17.2361 39.2322 16.9127 38.8333 16.9127H35.9444Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M15.299 24.584C15.171 24.392 15.3086 24.1349 15.5394 24.1349H40.9996V27.0238C40.9996 27.8215 40.3529 28.4682 39.5551 28.4682H32.3803L31.6793 31.6227C31.3856 32.9445 30.2133 33.8849 28.8593 33.8849H26.4749L25.6134 37.7616C25.3197 39.0834 24.1473 40.0238 22.7933 40.0238H17.7006C16.3145 40.0238 15.2848 38.7402 15.5855 37.3871L17.6477 28.1071L15.299 24.584Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M20.1769 22.3612C20.0109 22.6101 20.0782 22.9464 20.3271 23.1123C20.576 23.2783 20.9123 23.211 21.0782 22.9621L22.4032 20.9746C22.5692 20.7257 22.5019 20.3894 22.253 20.2234C22.0041 20.0575 21.6678 20.1247 21.5019 20.3737L20.1769 22.3612Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M23.5482 22.3612C23.3822 22.6101 23.4495 22.9464 23.6984 23.1123C23.9473 23.2783 24.2836 23.211 24.4496 22.9621L25.7746 20.9746C25.9405 20.7257 25.8732 20.3894 25.6243 20.2234C25.3754 20.0575 25.0391 20.1247 24.8732 20.3737L23.5482 22.3612Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M26.9167 22.3612C26.7507 22.6101 26.818 22.9464 27.0669 23.1123C27.3158 23.2783 27.6521 23.211 27.818 22.9621L29.143 20.9746C29.309 20.7257 29.2417 20.3894 28.9928 20.2234C28.7439 20.0575 28.4076 20.1247 28.2417 20.3737L26.9167 22.3612Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.3598 31.6702C24.5601 30.7682 23.8737 29.9127 22.9497 29.9127H21.0136C20.3366 29.9127 19.7504 30.3829 19.6036 31.0438L18.6406 35.3772C18.4402 36.2792 19.1266 37.1349 20.0507 37.1349H21.9877C22.6648 37.1349 23.2511 36.6646 23.3978 36.0035L24.3598 31.6702ZM22.9497 30.9961H21.0136C20.8444 30.9961 20.6978 31.1136 20.6611 31.2788L19.6982 35.6122C19.648 35.8377 19.8196 36.0516 20.0507 36.0516H21.9877C22.157 36.0516 22.3036 35.934 22.3403 35.7688L23.3023 31.4354C23.3523 31.2099 23.1807 30.9961 22.9497 30.9961Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M35.2222 18.3572V17.6349C35.2222 17.2361 35.5456 16.9127 35.9444 16.9127H38.8333C39.2322 16.9127 39.5556 17.2361 39.5556 17.6349V18.3572H41L40.9996 27.0238C40.9996 27.8216 40.3529 28.4683 39.5551 28.4683H32.3804L31.6794 31.6227C31.3856 32.9445 30.2133 33.8849 28.8593 33.8849H26.4749L25.6134 37.7616C25.3197 39.0834 24.1473 40.0238 22.7933 40.0238H17.7006C16.3145 40.0238 15.2848 38.7403 15.5855 37.3871L17.6477 28.1072L15.4692 24.8394C15.1808 24.5753 15 24.1957 15 23.7738V21.2461C16.5955 21.2461 17.8889 19.9527 17.8889 18.3572H35.2222ZM16.4444 24.1349H39.9167V19.4405H18.8227C18.4485 20.7634 17.4062 21.8057 16.0833 22.1799V23.7738C16.0833 23.9733 16.245 24.1349 16.4444 24.1349ZM17.0238 25.2183L18.8056 27.8909L16.6431 37.6222C16.4927 38.2987 17.0075 38.9405 17.7006 38.9405H22.7933C23.6396 38.9405 24.3723 38.3527 24.5559 37.5266L26.8096 27.3849H39.5551C39.7546 27.3849 39.9163 27.2233 39.9163 27.0238V25.2183H17.0238ZM36.3056 18.3572V17.9961H38.4722V18.3572H36.3056ZM27.7123 28.4683H31.2706L30.6218 31.3877C30.4382 32.2138 29.7055 32.8016 28.8593 32.8016H26.7494L27.7123 28.4683Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
i.__tags = [];
export {
  i as MetricCrimeIcon
};
//# sourceMappingURL=index.es387.js.map
